<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">任务反馈</div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content">
        <el-form-item label="任务名称" prop="TaskTiltle">
          <el-input v-model="ruleform.TaskTiltle" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="ChargerName">
          <el-input v-model="ruleform.ChargerName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="Phone">
          <el-input v-model="ruleform.Phone" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="任务响应时间" prop="PlanResponseTime">
          <el-input v-model="ruleform.PlanResponseTime" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="执行状态" prop="ExecStatus">
          <el-radio-group v-model="ruleform.ExecStatus" @change="execStatusChanged">
            <el-radio label="2">已完成</el-radio>
            <el-radio label="1">未完成</el-radio>
            <el-radio label="4">任务关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="FeedbackDesc">
          <el-input type="textarea" v-model="ruleform.FeedbackDesc"></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="submitForm('ruleform')">提交</el-button>
        </el-form-item>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../../app";
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../../apis";

export default {
  name: "ZJEmergencyComponentTaskFeedback",
  componentName: "ZJEmergencyComponentTaskFeedback",
  components: {},
  props: {
    currentTask: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      ruleform: $.extend(
        {},
        { ExecStatus: "", FeedbackDesc: "" },
        this.currentTask
      ),
      rules: {
        ExecStatus: [
          { required: true, message: "请选择执行状态", trigger: "blur" },
        ],
        FeedbackDesc: [
          { required: true, message: "请填写反馈内容", trigger: "blur" },
          { min: 0, max: 500, message: "长度最长为500个字符", trigger: "blur" },
        ],
      },
      msgkey: {
        emergencyFeedbackKey:
          "MessageKey_EmergencyFeedBack" + this.currentTask.ExecutId,
        emergencyFinishTaskKey:
          "MessageKey_EmergencyFinishTask" + this.currentTask.ExecutId,
      },
    };
  },
  methods: {
    submitForm(formName) {
      let that = this;

      this.$refs[formName].validate().then((valid) => {
        if (valid) {
          //插入反馈数据
          new MyApis.ExecutFeedbackApi()
            .AddItem(that.feedback)
            .then((r) => {
              let data = r.data.Data;
              if (data) {
                //增加反馈成功，发送反馈成功消息
                that.$notify.broadcase({
                  key: that.msgkey.emergencyFeedbackKey,
                  data: that.feedback,
                });

                //更新任务状态
                new MyApis.ExecutTaskApi()
                  .UpdateItem(that.currentTask)
                  .then((r) => {
                    let data = r.data.Data;
                    if (data) {
                      //发送任务完成消息
                      console.log(
                        "broadcase : " + that.msgkey.emergencyFinishTaskKey
                      );
                      that.$notify.broadcase({
                        key: that.msgkey.emergencyFinishTaskKey,
                        data: that.currentTask,
                      });

                      that.$message({
                        message: "反馈任务成功！",
                        type: "success",
                      });
                      //关闭当前弹窗
                      that.$emit("handlerclose");
                    } else {
                      that.$message({
                        message: "更新任务状态失败！",
                        type: "error",
                      });
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                    that.$message({
                      message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                      type: "error",
                    });
                  });
              } else {
                that.$message({
                  message: r.RspMsg ? r.RspMsg : "反馈失败！",
                  type: "error",
                });
              }
            })
            .catch((e) => {
              console.error(e);
              that.$message({
                message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                type: "error",
              });
            });
        }
      });
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    execStatusChanged: function (value) {
      this.currentTask.TaskStatus = value;
    },
  },
  computed: {
    feedback: function () {
      let uuid = ZJApp.ZJUtils.uuid();
      let deptId =
        ZJApp.ZJUser.current.Departments.length > 0
          ? ZJApp.ZJUser.current.Departments[0].OrgId
          : "error-no-department";

      var feedback = {
        Creater: ZJApp.ZJUser.current.UserName,
        Modifier: ZJApp.ZJUser.current.UserName,
        CreateTime: new Date(),
        ModifyTime: new Date(),
        Validity: 1,
        OrgId: deptId,
        FeedbackId: uuid,
        ExecutId: this.ruleform.ExecutId,
        ExecutTaskId: this.ruleform.ExecutTaskId,
        TaskTiltle: this.ruleform.TaskTiltle,
        TaskDesc: this.ruleform.TaskDesc,
        FeedType: "1", //反馈类型(1-事件反馈2-事态上报)
        Charger: this.ruleform.ChargerName,
        TelPhone: this.ruleform.Phone,
        PlanResponseTime: this.ruleform.PlanResponseTime,
        ExecStatus: this.ruleform.ExecStatus,
        FeedbackDesc: this.ruleform.FeedbackDesc,
      };
      return feedback;
    },
  },
  watch: {
    currentTask: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        // eslint-disable-next-line no-undef
        this.ruleform = $.extend(
          {},
          { ExecStatus: "", FeedbackDesc: "" },
          this.currentTask
        );
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>